import { Influencer } from '@foodfluence/shared';

type WalletPayoutIntroInfluencer = Pick<Influencer, 'id' | 'showWalletPayoutProviderIntro'> | null | undefined;

/** True until the user dismisses the Whop payout provider intro on wallet. */
export const shouldShowWalletPayoutIntro = (influencer: WalletPayoutIntroInfluencer): boolean => {
  if (!influencer?.id) return false;
  return influencer.showWalletPayoutProviderIntro !== false;
};
